import { RegistryWidgetsType } from '@rjsf/utils';
import {
  CurrencyInput,
  DateInput,
  IntegerInput,
  ProductAddressInput,
  SelectInput,
  ShowAdvancedButton,
  ShowAllButton,
  StatusSelectionInput,
  SupplierSelectionInput,
  TermSelectionInput,
  TextInput
} from '../JSONSchemaForm';

export const outsideInventoryWidgets: RegistryWidgetsType = {
  SupplierSelectionInput,
  TermSelectionInput,
  StatusSelectionInput,
  ProductAddressInput,
  TextInput,
  DateInput,
  CurrencyInput,
  ShowAdvancedButton,
  ShowAllButton,
  IntegerInput,
  SelectInput
};
